import { Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const GiftSelectorSection = styled.section`
    padding-top: ${getPurpurSpacing('200')};
    padding-bottom: ${getPurpurSpacing('600')};
    position: relative;
`;

export const GiftListHeading = styled(Heading)`
    margin-bottom: ${getPurpurSpacing('300')};
`;
